import mapboxgl from 'mapbox-gl';

const {
    accessToken = null,
    mapboxStyleUsername = null,
    mapboxStyleId = null,
} = window.mapbox_config;

mapboxgl.accessToken = accessToken;

const mapBoundsForFeatures = features => {
    const bounds = features.reduce(
        (boundsObject, feature) => boundsObject.extend(feature.geometry.coordinates),
        new mapboxgl.LngLatBounds(),
    );
    return bounds;
};

const createPopup = feature => {
    return new mapboxgl.Popup({
        className: 'map-popup-container',
        closeButton: false,
        maxWidth: 'none',
    })
        .setLngLat(feature.geometry.coordinates)
        .setHTML(feature.properties.popupHTML);
};

const initializeMap = mapContainer => {
    const geojson = JSON.parse(mapContainer.dataset.mapGeojson);
    const isSingleLocation = geojson.features.length === 1;
    const areaOptions = isSingleLocation
        ? {
              center: geojson.features[0].geometry.coordinates,
              zoom: geojson.features[0].properties.zoom,
          }
        : {
              bounds: mapBoundsForFeatures(geojson.features),
              fitBoundsOptions: { padding: 80 },
          };

    const mapOptions = {
        ...areaOptions,
        attributionControl: true,
        container: mapContainer,
        cooperativeGestures: true,
        style: `mapbox://styles/${mapboxStyleUsername}/${mapboxStyleId}`,
        language: 'de',
    };

    const map = new mapboxgl.Map(mapOptions);
    map.addControl(new mapboxgl.NavigationControl());

    map.on('load', () => {
        geojson.features.forEach(feature => {
            new mapboxgl.Marker({ color: '#00508c' })
                .setLngLat(feature.geometry.coordinates)
                .setPopup(createPopup(feature))
                .addTo(map);
        });
    });
};

document.querySelectorAll('[data-map-wrapper]').forEach(wrapper => {
    const container = wrapper.querySelector('[data-map-mount]');

    wrapper.addEventListener(
        'onplaceholderchange',
        e => {
            if (e.detail.consent) {
                initializeMap(container);
            }
        },
        {
            once: true,
            passive: true,
        },
    );
});
